module.exports = __webpack_public_path__ + "static/flags/BT-bc0995eb0b433f1ced0b276493564e1e.gif";